<div>
  <h2>Download data</h2>
  <form (submit)="downloadData()" [formGroup]="downloadDataForm" autocomplete="off">
    <div class="form-container">

      <mat-form-field appearance="outline" class="full-width-input">
        <mat-label>Years</mat-label>
        <mat-select [formControl]="yearsControl" multiple>
          <mat-option #allSelected (click)="toggleAllYearsSelection()" [value]="0"><strong>All</strong></mat-option>
          <mat-option *ngFor="let year of years" [value]="year" (click)="toggleYearPerOne()">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width-input">
        <mat-label>Countries</mat-label>
        <mat-select [formControl]="countriesControl" multiple>
          <mat-option #allCountrySelected (click)="toggleAllCountriesSelection()" [value]="0"><strong>All</strong></mat-option>
          <mat-option *ngFor="let country of countries" [value]="country.id" (click)="toggleCountryPerOne()">{{country.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="download-button-container">
        <button [disabled]="downloadDataForm.invalid" mat-raised-button color="primary" type="submit">
          <span>Download</span>
        </button>
      </div>
    </div>
  </form>
</div>
